module Meevo.Components.Controls {

    export class MeevoCopyTextController implements ng.IComponentController {
        $inject = ["$timeout", "$translate"];

        public ngModel: string;
        public contentKey: string;
        public tabindex: number | undefined;
        public copySuccess: boolean = false;
        public successText: string = "Copied!";

        constructor(private $timeout: angular.ITimeoutService) { }

        async copyText(): Promise<void> {
            try {
                if (navigator["clipboard"]) {
                    await navigator["clipboard"].writeText(this.ngModel);
                    this.copySuccess = true;
                    this.$timeout(() => {
                        this.copySuccess = false;
                    }, 2000);
                } else {
                    this.fallbackCopyText(this.ngModel);
                }
            } catch (err) {
                console.error('Failed to copy text', err);
                this.fallbackCopyText(this.ngModel);
            }
        }

        private fallbackCopyText(text: string): void {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    this.copySuccess = true;
                    this.$timeout(() => {
                        this.copySuccess = false;
                    }, 2000);
                } else {
                    console.error('Fallback: Copy command was unsuccessful');
                }
            } catch (err) {
                console.error('Fallback: Unable to copy', err);
            }

            document.body.removeChild(textArea);
        }

    }

    angular.module('meevo.components.controls')
        .component('meevoCopyText', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/copyText/copyText.html',
            bindings: {
                ngModel: '<',
                contentKey: '@',
                tabindex: '<'
            },
            controller: [
                "$timeout",
                "$translate",
                MeevoCopyTextController
            ],
            controllerAs: 'vm'
        });

}